<template>
  <div class="detailed-toolbar" v-if="canViewToolbar">
    <v-toolbar class="toolbar--content">
      <div class="content-container">
        <v-flex xs12 sm7 md5>
          <h2
            :class="['text-h5 text-h5 clubhouse-name', !isDashboard ? 'pointer' : '']"
            @click="routeToDashboard"
          >
            {{ clubhouseName || '' }}
          </h2>
        </v-flex>

        <!-- <div class="membership-select">
          <MembershipSelect :items="memberships"></MembershipSelect>
          <MembershipSelect :items="ownedClubhouses"></MembershipSelect>
        </div> -->

        <!-- Desktop/Tablet menu -->
        <v-flex sm5 md7 class="flex-content hidden-sm-and-down">
          <div class="tabs-container">
            <v-tabs v-model="active" slider-color="primary" class="toolbar-wrapper">
              <v-tabs-slider
                class="slider"
                color="primary"
                :style="slider"
                secondary
              ></v-tabs-slider>
              <v-tab
                v-for="{ value, routeName } in toolbarMenu"
                :key="value"
                :to="{
                  path: `/clubhouse/${$route.params.clubhouseID}/${value}`,
                  props: true,
                  name: `${routeName}`,
                  params: {
                    clubhouseID: `${$route.params.clubhouseID}`,
                    clubhouse: clubhouseInfo,
                  },
                }"
                :class="$vuetify.theme.dark ? 'dark-title' : 'light-title'"
                ripple
              >
                <!-- clubhouseID: `${userClubhouse ? userClubhouse.id : ''.id}`, -->
                <span>{{ value }}</span>
              </v-tab>
            </v-tabs>
          </div>
        </v-flex>
      </div>

      <!-- Mobile menu -->
      <div class="hidden-md-and-up">
        <v-menu offset-y class="1hidden-md-and-up">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon text slot="activator" color="primary" dark>
              <v-icon>menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="({ value }, index) in toolbarMenu"
              :key="index"
              :to="`/clubhouse/${clubhouseInfo ? clubhouseInfo.id : ''}/${value}`"
            >
              <v-list-item-title>{{ utility_capitalize(value) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </div>
  <div v-else></div>
</template>

<script>
// TODO Toolbar does not re-render on clubhouse update
import { mapGetters } from 'vuex';
import MembershipSelect from '@/components/MembershipSelect';
import meMixin from '@/mixins/meMixin';
import utilityMixin from '@/mixins/utilityMixin';
import userClubPermissionMixin from '@/mixins/userClubPermissionMixin';

export default {
  name: 'detailed-toolbar',
  mixins: [meMixin, utilityMixin, userClubPermissionMixin],
  components: {
    MembershipSelect,
  },
  props: [],

  data() {
    return {
      active: null,
      currentClub: {},
    };
  },

  beforeCreate() {
    this.$store.dispatch('clubhouses/list');
  },

  mounted() {
    if (this.$route?.params?.clubhouseID) {
      this.$store
        .dispatch('clubhouses/show', { id: this.$route?.params?.clubhouseID })
        .then((res) => {
          this.currentClub = res;
        });
    }
  },

  computed: {
    ...mapGetters({
      userClubhouse: 'users/getClubhouse',
      clubhouses: 'clubhouses/list',
      clubhouseInfo: 'clubhouses/getClubhouse',
      userInfo: 'users/getMe',
      hasSeasons: 'users/hasSeasons',
    }),

    clubhouseName() {
      return this.canViewToolbar
        ? this.clubhouseInfo?.name ?? this.currentClub?.name
        : this.userClubhouse.name ?? '';
    },

    limitedClubCheck() {
      if (this.userClubhouse) {
        return this.userClubhouse.id === 29 && this.userClubhouse.name !== 'Showroom Clubhouse';
      }
      return true;
    },

    ownedClubhouses() {
      const chList = this.clubhouses?.filter((clubhouse) => {
        return clubhouse.uuid === this.userInfo.club[0].uuid;
      });
      return chList.map((club) => {
        return club.name;
      });
    },

    // TODO need to factor in multiple clubhouses
    // clubhouse() {
    //   if (!this.clubhouses) {
    //     return '';
    //   }
    //   const club = this.clubhouses.filter(clubhouse => {
    //     if (this.userInfo.club === null) {
    //       return;
    //     }
    //     if (this.userInfo.club) {
    //       //   let club = this.userInfo.club.filter(ch => {
    //       //     return clubhouse.uuid === ch.uuid
    //       //   })
    //       //   return club
    //       return clubhouse.uuid === this.userInfo.club[0].uuid;
    //     }
    //   });

    //   return club[0];
    // },

    slider() {
      let display = 'display: none';

      this.toolbarMenu.forEach((tab) => {
        for (const key in tab) {
          if (tab.hasOwnProperty(key)) {
            if (tab[key].indexOf(this.$route.name) > -1) {
              display = 'display: flex';
              return display;
            }
            return display;
          }
        }
      });
      return display;
    },

    filteredTabs() {
      return this.tabs.filter((item) => {
        return item !== null && item?.value !== undefined;
      });
    },

    filteredLimitedTabs() {
      return this.limitedTabs.filter((item) => {
        return item !== null && item?.value !== undefined;
      });
    },

    filteredNoSeasonTabs() {
      return this.noSeasonTabs.filter((item) => {
        return item !== null && item?.value !== undefined;
      });
    },

    toolbarMenu() {
      let menu = [];

      menu = [
        {
          routeName: 'clubhouseSimulators',
          value: `${this.$tc('clubhouse.simulators.simulator', 2)}`,
          permission:
            !this.limitedClubCheck &&
            (this.isClubOwner || this.hasClubAdminPermission || this.hasClubMetricsPermission),
        },
        {
          routeName: 'clubhouseMembers',
          value: `${this.$tc('clubhouse.members.member', 2)}`,
          permission:
            this.isClubOwner || this.hasClubAdminPermission || this.hasClubEmailPermission,
        },
        {
          routeName: 'clubhouseEvents',
          value: 'events',
          permission: this.isClubOwner || this.hasClubAdminPermission,
        },
        {
          routeName: 'clubhouseSeasons',
          value: `${this.$tc('clubhouse.seasons.season', 2)}`,
          permission: !this.limitedClubCheck && (this.hasSeasons || this.hasClubSeasonsPermission),
        },
        // TODO turn on when club fitting set up
        // {
        //   routeName: 'clubhouseFitting',
        //   value: 'Club Fitting',
        //   permission: !this.limitedClubCheck && this.hasClubFitterPermission,
        // },
        {
          routeName: 'clubhouseStats',
          value: `${this.$tc('clubhouse.stats.stat', 2)}`,
          permission:
            !this.limitedClubCheck &&
            // TODO update this if we want club owner to view
            // (this.isClubOwner || this.hasClubAdminPermission || this.hasClubMetricsPermission),
            // (this.hasClubAdminPermission || this.hasClubMetricsPermission),
            this.hasClubMetricsPermission, //* only allow metrics permission access
        },
      ]
        .filter((item) => {
          return item !== null && item?.value !== undefined && item.permission;
        })
        .map((item) => {
          return {
            routeName: item.routeName,
            value: item.value,
          };
        });

      return menu;
    },

    isDashboard() {
      const { name } = this.$route;
      return name === 'clubhouseDashboard';
    },
  },

  methods: {
    routeToDashboard() {
      const { name, params = {} } = this.$route;
      if (name !== 'clubhouseDashboard') {
        this.$router.push({
          name: 'clubhouseDashboard',
          props: true,
          params: {
            clubhouseID: params.clubhouseID,
          },
        });
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.detailed-toolbar {
  z-index: 5;
  position: absolute;
  width: 100%;
  top: 64px;
}

.detailed-toolbar .v-toolbar {
  background-color: rgba(245, 245, 245, 0.8) !important;
  box-shadow: none !important;
}

.detailed-toolbar .toolbar-wrapper >>> .v-tabs-bar.theme--light,
.detailed-toolbar .toolbar-wrapper >>> .v-tabs-bar.theme--dark {
  background-color: transparent;
}

.content-container {
  margin: 0 auto;
  width: 1280px;
  display: flex;
}

.content-container .flex,
.content-container .membership-select,
.content-container .flex-content {
  flex: 1;
}

.clubhouse-name {
  line-height: 3em !important;
  text-transform: uppercase;
  color: var(--grey-light, #828282);
  margin-left: 0.4375rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease-in-out;
}

.clubhouse-name.pointer:hover {
  color: var(--grey-dark, #3e3e3e);
}

.membership-select {
  max-width: 200px;
}

.light-title {
  color: #212121;
}

.dark-title {
  color: #eeeeee;
}

.flex-content {
  display: flex;
  justify-content: flex-end;
}

/* Not sure if width needed */
/* .tabs-container { */
/* * >>> .v-slide-group__content.v-tabs-bar__content { */
/* position: relative; */
/* top: 4px; */
/* } */

* >>> .v-tabs-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  height: 68px;
}

@media (max-width: 1280px) {
  .content-container {
    width: 1000px;
  }
}

@media (max-width: 1024px) {
  .content-container {
    width: 960px;
  }
}

@media (max-width: 960px) {
  .content-container {
    width: 720px;
  }
  .detailed-toolbar {
    /* top: 48px; */
    top: 56px;
  }
}

@media (max-width: 600px) {
  .content-container {
    width: 100%;
    min-width: 290px;
  }

  .clubhouse-name {
    margin-left: 1.313rem;
    max-width: 290px;
  }

  .detailed-toolbar {
    top: 56px;
  }
}
</style>

<style>
.theme--light .tabs-container .v-tabs-bar {
  background-color: transparent !important;
}
.theme--dark .detailed-toolbar .v-tabs .tabs-bar {
  background-color: transparent !important;
}
.theme--dark .detailed-toolbar .v-tabs-bar .v-tab span {
  color: #222222 !important;
}
</style>
